<template>
  <BittsTooltip :mount-to-body="true">
    <span class="text-sm text-neutral-text-strong">
      {{ params.textPlain }}
    </span>
    <template #title v-if="params.tooltipText">
      {{ params.tooltipText }}
      <button
        v-if="params.link"
        type="button"
        class="font-bold"
        @click="navigateToLink"
      >
        <span>{{ params.link?.text }}</span>
        <FontAwesomeIcon
          :icon="['fak', 'open-link']"
          :style="{ height: '14px', width: '14px' }"
          class="bitts-link__icon ml-4"
        />
      </button>
    </template>
  </BittsTooltip>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

import { useRouterWrapper } from '@/composables/useRouterWrapper';
const props = defineProps<{
  params: {
    textPlain?: string;
    tooltipText?: string;
    link?: {
      text: string;
      url: string;
      to?: { name: string };
    };
  };
}>();
const { navigateOrOpen } = useRouterWrapper();
function navigateToLink() {
  const link = props?.params?.link;
  if (!link) return;
  if (link.to) {
    navigateOrOpen(link.to);
    return;
  }
  if (link.url) {
    const url = new URL(link.url);
    window.open(url.href, '_blank');
  }
}
</script>
